import React, {useState} from 'react';
import '../components/styles/Search.css'

const Search = () => {
    const [show, setShow] = useState(true);
  return (
    <>
  <div className='hello' onClick={() => setShow(!show)}>
    <h2>Search</h2>
    {show ? <i className='fas fa-search search'></i> : '' }
    <input type="text" onClick={() => setShow(!show)}/>
    <hr />
  </div>
  </>
  )
}

export default Search
